<template>
<button type="button" :disabled="buttonDisabled" @click="handleClick">
  <slot v-if="!waiting">
    <span>{{ $t("js.actions.submit") }}</span>
  </slot>
  <slot name="waiting" v-else>
    <IndeterminateSpinner/>
  </slot>
</button>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import IndeterminateSpinner from "@/components/backend/live/IndeterminateSpinner.vue";

const props = defineProps({
  disabled: {
    type: Boolean,
    default: false,
  },
  waitTime: {
    type: Number,
    default: 0,
  },
  onClick: {
    type: Function,
    required: true,
  },
});

const waiting = ref<boolean>(false);

const buttonDisabled = computed(() => waiting.value || props.disabled);

const handleClick = async (event: Event) => {
  waiting.value = true;
  await new Promise(res => setTimeout(res, props.waitTime));
  try {
    await Promise.resolve(props.onClick(event));
  } catch (error) {
    console.error(error);
  } finally {
    waiting.value = false;
  }
};
</script>
